import { Grid, Typography } from "antd"
import { StyledHeadingWrapper, StyledTitleWrapper, StyledWrapper } from "components/content-top-bar/top-content-bar.styles"
import { ReactNode, useState } from "react";
import { useNavigate } from "react-router-dom";

// import { StyledWrapper } from "../time-price-input/time-price-styles"

const { useBreakpoint } = Grid;

interface EventDetailsTopbarProps {
    name: string;
    renderButtons?: ReactNode;
}

const EventDetailsTopbar = ({ name, renderButtons }: EventDetailsTopbarProps) => {

    const [eventName] = useState<string>(name);
    const screens = useBreakpoint();

    const navigate = useNavigate();
    const handleBreacum = () => {
        navigate("/events")
    }

    return (
        <StyledWrapper className='cstm_head'>
            <StyledHeadingWrapper className='hed_ttl'>
                <StyledTitleWrapper className='hht_data'>
                    <Typography.Title className='title'>
                        <span className="btn" onClick={handleBreacum}>Event List</span>
                        <span>/</span>
                        <span>{eventName}</span>
                    </Typography.Title>
                </StyledTitleWrapper>
                {renderButtons && !screens.lg && <div>{renderButtons}</div>}
            </StyledHeadingWrapper>
            {renderButtons && screens.lg && <div>{renderButtons}</div>}
        </StyledWrapper>

    )
}

export default EventDetailsTopbar;

